import React, { useState } from "react";
import { Button, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    IGame,
    IMasterTournament,
    ISiteSetting,
    ITeam,
    ITournament,
} from "../types/api";
import GameActionModal from "./GameActionModal";
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import { deleteGame, postponeGame } from "../lib/api";
import { alertActions } from "../features/alert/alertSlice";
import { Breakpoint } from "../hooks/useBreakpoint";
import { isChildTournament, isXOrSmaller } from "../lib/utils";
import { AUTH_LEVELS } from "../lib/globals";

const GameActionButtons = ({
    game,
    selectedTeam,
    selectedTournament,
    displayDeleteLink,
    handleDelete,
    setSchedule,
    breakpoint,
    scheduleType,
}: {
    game: IGame;
    selectedTeam?: ITeam;
    selectedTournament?: ITournament | IMasterTournament;
    displayDeleteLink?: ISiteSetting;
    handleDelete: (gameId: number) => void;
    setSchedule: React.Dispatch<React.SetStateAction<IGame[]>>;
    breakpoint: Breakpoint;
    scheduleType: "team" | "tournament";
}) => {
    const { id, home: homeTeam } = game;
    const [show, setShow] = useState<Record<string, boolean>>({
        delete: false,
        postpone: false,
        cancel: false,
        accept: false,
        decline: false,
    });
    const user = useAppSelector(state => state.auth.user);
    const dispatch = useAppDispatch();
    const today = new Date();
    const gameDate = new Date(game.date);
    const isChild = isChildTournament(selectedTournament);

    const handleClose = (key: string) =>
        setShow(prev => ({
            ...prev,
            [key]: false,
        }));

    const handleShow = (key: string) =>
        setShow(prev => ({
            ...prev,
            [key]: true,
        }));

    const handleAction = async (action: keyof typeof show) => {
        handleClose(action);
    };

    return (
        <>
            {AUTH_LEVELS.sitemanagement.includes(user!.userLevel) && (
                <tr className="gameActions">
                    <td colSpan={isXOrSmaller("md", breakpoint) ? 7 : 8}>
                        <Stack direction="horizontal" gap={2}>
                            <Button onClick={() => handleShow("delete")}>
                                Delete
                            </Button>
                            <Link
                                className="btn btn-primary"
                                to={`${
                                    selectedTeam
                                        ? `/coachs-clubhouse/team/${selectedTeam!.id}/schedule/game/${id}/logs`
                                        : `/tournament-management/game-logs/${game.id}`
                                }`}
                            >
                                View Game Logs
                            </Link>
                        </Stack>
                    </td>
                </tr>
            )}

            {Object.entries(show).map(([key, value]) => (
                <GameActionModal
                    key={key}
                    action={key}
                    show={value}
                    handleClose={handleClose}
                    handleAction={handleAction}
                    game={game}
                />
            ))}
        </>
    );
};

export default GameActionButtons;
